import script from "./FileListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileListItem.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
